
import dayjs from 'dayjs' // 时间转换
import dealerMt from '~/components/company/softwareComponent/dealerMt.vue'
// import hongkong from '~/components/dealer/regulatory/hongKongPopUp'
// import regulatoryPopUp from '~/components/dealer/regulatory/regulatoryPopUp.vue'
import authenticationmt from '@/components/company/v2/authenticationmt.vue'
import dealerh5mt45 from '@/components/company/v2/dealer-h5-mt45.vue'
import companyBasic from '@/components/company/v2/companyBasic.vue'
import individuaidentification from '~/components/company/softwareComponent/individuaidentification.vue'
// import dealerTisk from '@/components/company/head/dealerTisk.vue'
import riskWarning from '@/components/company/head/riskWarning.vue'
import dealerModule from '@/components/dealer/head/dealerModule.vue'
export default {
  components: {
    dealerMt,
    // 'regulatory-pop-up': regulatoryPopUp,
    // 'hong-kong': hongkong,
    'authen-ticationmt': authenticationmt,
    'dealer-h5mt': dealerh5mt45,
    companyBasic,
    individuaidentification,
    // 'dealer-tisk': dealerTisk,
    'risk-warning': riskWarning,
    'dealer-module': dealerModule
  },
  inject: ['detail'],
  // inject: ['tips', 'skyeye', 'account', 'weburl', 'EnterpriseCode', 'isExistAdmin', 'marketstrategy','mt4mt5AppraiseData'],
  props: {
    prdchangrecord: {
      // 变更历史
      type: Object,
      default: () => {}
    },
    dealerCode: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      angetype: false, // 变更类型
      angelabel: false, // 变更标签
      angetime: false, // 时间
      basicInfo: {}, // 变更大类型选择
      selebasic: [], // 变更类型选择
      labelInfo: {}, // 变更标签选择
      selelabel: [], // 变更标签选择
      timeInfo: {}, // 变更时间选择
      seletime: [], // 变更时间选择
      seleNum: 0, // 变更类型选择数
      page: {
        size: 5,
        index: 1
      },
      softval: {},
      companyBasic: {},
      serverIPObj: [],
      updateDate: '',
      isIpDialog: false,
      changrecord: {},
      urltype: 'webUrl', // 网址跳转类型
      tipstype: '',
      ourl: '', // 官方网址
      moduleShow: false, // 弹框是否显示
      modelshow: false,
      isnewdata: true, // 是否可加载数据
      loading: false,
      isshadow: false, // 是否展示阴影

      main: {},
      mt4mt5AppraiseData: {},
      skyeye: {}
    }
  },
  computed: {
    isZh() {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-cn' || code == 'zh-tw' || code == 'zh-hk' || code == 'zh') {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    this.changrecord = this.prdchangrecord
    if (this.changrecord?.count > 0) {
      this.changrecord?.changeHistoryList?.forEach((item, ind) => {
        item.index = this.$store.state.mobile ? ind + 1 : this.page.index == 1 ? ind + 1 : this.page.size * (this.page.index - 1) + (ind + 1)
      })
    }
    this.basicInfo = this.changrecord?.tabInfo?.basicList[0]
    if (this.changrecord?.changeHistoryList?.length >= this.changrecord?.count) this.isnewdata = false
    else this.isnewdata = true
  },
  mounted() {
    console.log('changrecordchangrecord', this.$refs.changrecord)
    this.getchangh()
  },
  methods: {
    changscroll(event) {
      const container = event.target
      const isRight = this.$store.state.LanguageCode == 'ar' ? container.scrollLeft >= 0 : container.scrollLeft <= 0
      this.isshadow = !isRight
    },
    modelshowfn() {
      this.modelshow = false
      this.moduleShow = false
      this.$refs.riskwarning && this.$refs.riskwarning.close()
    },
    closemodefn() {
      this.moduleShow = false
      document.body.style.overflow = 'auto'
      this.$nextTick(() => {
        this.modelshow = false
      })
    },
    close() {
      // 关闭弹框
      this.moduleShow = false
      document.body.style.overflow = 'auto'
      this.$nextTick(() => {
        this.modelshow = false
        this.$refs.tisk && this.$refs.tisk.close()
      })
    },
    closetisk() {
      this.moduleShow = false
      document.body.style.overflow = 'auto'
      this.$nextTick(() => {
        this.$refs.tisk && this.$refs.tisk.close()
      })
    },
    setDom(v) {
      if (v.includes('https://')) {
        if (v.includes(',')) {
          return v.split(',').join(',<br>')
        } else if (v.includes('，')) {
          return v.split('，').join(',<br>')
        } else {
          return v
        }
      } else {
        return v
      }
    },
    getchangh() {
      console.log('this.changrecord:变更历史 111111111111111111111', this.changrecord)

      if (this.changrecord && this.changrecord.count > 0) {
        this.$refs.changrecord.forEach((item, ind) => {
          console.log(item.clientHeight)
          if (item.clientHeight > 110) {
            this.changrecord.changeHistoryList[ind].ishmax = true
          }
        })
        this.$forceUpdate()
      }
    },
    setchangh(i) {
      this.changrecord.changeHistoryList[i].ishmax = false
      this.$forceUpdate()
    },
    pingIcon(i) {
      if (i == 1) return 'https://resources1.interface003.com/web20/img/commen/green.gif'
      else if (i == 2) return 'https://resources1.interface003.com/web20/img/commen/yellow.gif'
      else if (i == 3) return 'https://resources1.interface003.com/web20/img/commen/red.gif'
      else return 'https://resources1.interface003.com/web20/img/commen/red.gif'
    },
    ipclone() {
      console.log('弹框关闭')
      // document.body.style.overflow = 'auto'
      document.querySelector('.el-table').scrollTop = 0
    },
    toggleLicence(obj) {
      console.log('父组件打开再一个组件')
      // this.$refs.popUp.show()
      this.getEEALicenceData(obj)
    },
    // 获取eea子牌照数据
    async getEEALicenceData(obj) {
      console.log('obj::: ', obj)
      if (!obj.regulationId) return
      const res = await this.$api.common
        .CV3(
          {
            traderCode: obj.traderCode,
            regulationId: obj.regulationId,
            languageCode: this.$store.state.LanguageCode,
            countryCode: obj.countryCode
          },
          {
            Routes: 'wikifx$traderlicensebyregulationid'
          }
        )
        .catch(() => {
          console.error('wikifx$traderlicensebyregulationid')
        })
      const rest = res.wikifx.traderlicensebyregulationid
      if (rest?.success) {
        console.log(rest.data, 'rest.data')
        this.$refs.popUpLicence.show(rest.data)
      }
    },
    setbaInfo(item) {
      console.log('item: ', item)
      console.log('changrecord.tabInfo.basicList', this.changrecord.tabInfo.basicList)
      console.log('selebasic', this.selebasic)
      item.subTagList.forEach((res) => {
        if (this.selebasic.includes(res.tabCode)) res.issele = true
      })
      this.basicInfo = item
    },
    setbasic(item) {
      console.log('item: ', item)
      console.log('变更类型子类')
      this.basicInfo.subTagList.forEach((res) => {
        if (res.tabCode == item.tabCode) {
          if (res.issele) {
            const index = this.selebasic.findIndex((e) => e == item.tabCode)
            console.log('index: ', index)
            if (index !== -1) {
              this.selebasic.splice(index, 1)
            }
            res.issele = false
          } else {
            this.selebasic.push(item.tabCode)
            res.issele = true
          }
        }
      })
      // this.changrecord.tabInfo.basicList.forEach((item)=>{
      //   if(item.tabCode == this.basicInfo.tabCode) item = this.basicInfo
      // })
      console.log('this.changrecord.tabInfo.basicList', this.changrecord.tabInfo.basicList)
      // this.$parent.$parent.changrecord = this.changrecord

      console.log('this.selebasic', this.selebasic)

      console.log('this.basicInfo: ', this.basicInfo)

      this.$forceUpdate()
      // this.getchangeall()
    },
    reas(i) {
      if (i == 1) {
        this.seleNum = 0
        this.selebasic = []
        // this.changrecord.tabInfo.basicList.forEach((item)=>{
        //   item.forEach((res)=>{
        //     res.issele = false
        //   })
        // })
        this.basicInfo.subTagList.forEach((res) => {
          res.issele = false
        })
      } else if (i == 2) {
        this.selelabel = []
        this.labelInfo = {}
      } else if (i == 3) {
        this.seletime = []
        this.timeInfo = []
      }
      // this.labelInfo = this.timeInfo = {}
      this.angetype = false
      this.page.size = 5
      this.page.index = 1
      this.$forceUpdate()
      this.getchangeall()
    },
    setbasicstat() {
      this.angetype = false
      console.log('this.angetype: ', this.angetype)
      this.seleNum = this.selebasic.length
      this.page.size = 5
      this.page.index = 1
      this.getchangeall()
    },
    setlabel(item) {
      this.labelInfo = item
      this.selelabel = [item.tabCode]
      this.angelabel = false
      this.page.size = 5
      this.page.index = 1
      this.getchangeall()
    },
    settime(item) {
      console.log('触发时间')

      this.timeInfo = item
      this.seletime = [item.tabCode]
      this.angetime = false
      this.page.size = 5
      this.page.index = 1
      this.getchangeall()
    },
    async getchangeall(i = 1) {
      console.log('this.selebasic', this.selebasic)
      console.log('this.selelabel', this.selelabel)
      console.log('this.seletime', this.seletime)
      if (this.loading) return
      this.loading = true
      if (i == 2) this.page.index = this.page.index + 1
      const ret = await this.$api.common.CV3(
        {
          code: this.dealerCode, // this.dealerCode
          type: 2, // 1交易商 2公司 3牌照 4软件
          pushGenerationTime: 0,
          pageIndex: this.page.index,
          pageSize: this.page.size,
          basicSubTabCodeList: this.selebasic,
          evaluateTabCodeList: this.selelabel,
          dateTabCodeList: this.seletime,
          pageType: 1
        },
        {
          Routes: 'wikifxagg$changehistoryall'
        }
      )
      console.log('ret: ', ret)
      if (ret?.wikifxagg?.changehistoryall?.data) {
        this.loading = false
        // if(i ==1) this.changrecord = ret?.wikifxagg?.changehistoryall?.data
        // else {
        //   ret?.wikifxagg?.changehistoryall?.data.changeHistoryList.forEach((item)=>{
        //     this.changrecord.changeHistoryList.push(item)
        //   })
        // }

        if (i == 1) {
          ret?.wikifxagg?.changehistoryall?.data.changeHistoryList.forEach((item, ind) => {
            item.index = this.$store.state.mobile ? ind + 1 : this.page.index == 1 ? ind + 1 : this.page.size * (this.page.index - 1) + (ind + 1)
          })
          this.changrecord = ret?.wikifxagg?.changehistoryall?.data
        } else {
          ret?.wikifxagg?.changehistoryall?.data.changeHistoryList.forEach((item, ind) => {
            this.changrecord.changeHistoryList.push(item)
          })
          this.changrecord?.changeHistoryList?.forEach((item, ind) => {
            item.index = ind + 1
          })
        }

        if (this.changrecord.changeHistoryList.length >= this.changrecord.count) this.isnewdata = false
        else this.isnewdata = true

        const changsrol = this.$refs.changsrol
        changsrol.scrollLeft = 0
      }

      setTimeout(() => {
        this.getchangh()
      }, 0)
    },
    popcord(i) {
      if (i == 1) {
        this.angelabel = this.angetime = false
        this.angetype = !this.angetype
      } else if (i == 2) {
        this.angetype = this.angetime = false
        this.angelabel = !this.angelabel
      } else {
        this.angelabel = this.angetype = false
        this.angetime = !this.angetime
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.page.index = val
      this.getchangeall()
      this.$parent.setsollchangercord()
    },
    linkbussine(item, type = 1, lintype = 1) {
      console.log('detail', this.detail)

      // lintype 1 整体 2 标题 3内容
      if (!item.bussinessId && type == 1) return
      if (item.showType == 5) return
      if (item.bussinessId == this.dealerCode) return
      console.log('item: ', item)
      /* 无业务 None = 0
          交易商 Trader = 1
          牌照 License = 2
          企业 Company = 3
          软件 Software = 4
          控制声明 ControlStatement = 5
          高管 Executive = 6
          商标 Trademark = 7
          官方登记号 OfficialRegistrationNumber = 8
          服务商 ServiceProvider = 10
          监管信息 Regulation = 11
          实勘 Survey = 100
          曝光 Exposure = 101
          调解 Mediation = 102
          Skyline Skyline = 103
          账户 Account = 9102
          监管机构 Regulator = 9109
          Website Website = 9110 */
      if (item.bussinessType == 1) window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${item.bussinessId}.html`)
      // else if(item.bussinessType == 2) this.getlicense(item,1,lintype) // this.showDialog(item)
      else if (item.bussinessType == 3) {
        window.open(`/${this.$store.state.LanguageCode}/company/${item.bussinessId}.html`)
      }
      // else if(item.bussinessType == 4) {
      //   this.getlicense(item,2,lintype) //  this.openmt({softwareId:item.bussinessId,softwareType:item.subBussinessId,name:item.details[0]?.subjectData[0]?.content})
      // }
      else if (item.bussinessType == 5) window.open(`/${this.$store.state.LanguageCode}/company/${item.bussinessId}.html`)
      else if (item.bussinessType == 6) window.open(`/${this.$store.state.LanguageCode}/employee/${item.bussinessId}.html`)
      else if (item.bussinessType == 7) window.open(`/${this.$store.state.LanguageCode}/company/${item.bussinessId}.html`)
      else if (item.bussinessType == 8) window.open(`/${this.$store.state.LanguageCode}/company/${item.bussinessId}.html`)
      else if (item.bussinessType == 10) window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/service/${item.bussinessId}.html`)
      // else if(item.bussinessType == 11)  this.showDialog(item)
      else if (item.bussinessType == 100) window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/survey/${item.bussinessId}.html`)
      else if (item.bussinessType == 101) window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/exposure/detail/${item.bussinessId}.html`)
      else if (item.bussinessType == 102) window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/exposure/safeguard/${item.bussinessId}.html`)
      // else if(item.bussinessType == 103)  this.getskyline(item)
      else if (item.bussinessType == 9109) window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/regulatory/${item.bussinessId}.html`)
      else if (item.bussinessType == 9110) this.statistics('3', item.bussinessId)
      else if (item.bussinessType == 9114) {
        if (!this.$store.state.mobile) this.$refs.authenticat.show()
        else this.$refs.h5mtDom.showMt()
      }
    },
    linkcp(item) {
      console.log('item: ', item)
      console.log('dealerCode', this.dealerCode)
      if (item.code == this.dealerCode) return
      if (item.code) window.open(`/${this.$store.state.LanguageCode}/company/${item.code}.html`)
    },
    async getlicense(item, type, lintype) {
      /* wikifxagg$changehistoryjumpinfo */
      const resean = await this.$api.common
        .CV3(
          {
            bussinessId: item.bussinessId,
            subBussinessId: item.subBussinessId,
            bussinessType: item.bussinessType,
            labelChangeType: item.labelChangeType,
            labelAreaType: lintype /* 无 None = 0 整体 Whole = 1 标题 Title = 2 内容 Content = 3 */,
            changeCode: item.changeCode,
            labelId: item.labelId || '', // skyline不传 其他具体看情况
            url: '' // skyline不传 其他具体看情况
          },
          {
            Routes: 'wikifxagg$changehistoryjumpinfo'
          }
        )
        .catch((err) => {
          console.log(err)
        })
      console.log('resean: ', resean)
      if (resean?.wikifxagg?.changehistoryjumpinfo?.data) {
        if (!resean?.wikifxagg?.changehistoryjumpinfo?.data.code) this.$toast(resean?.wikifxagg?.changehistoryjumpinfo?.data.toastInfo)
        else if (type == 1) this.showDialog(item)
        else if (type == 2) this.openmt({ softwareId: item.bussinessId, softwareType: item.subBussinessId, name: item.details[0]?.subjectData[0]?.content })
      }

      // if(resean?.wikifxagg?.changehistoryjumpinfo?.data?.url) window.open(resean?.wikifxagg?.changehistoryjumpinfo?.data?.url)
    },
    async getskyline(item) {
      /* wikifxagg$changehistoryjumpinfo */
      const resean = await this.$api.common
        .CV3(
          {
            bussinessId: item.bussinessId,
            subBussinessId: item.subBussinessId,
            bussinessType: item.bussinessType,
            labelChangeType: item.labelChangeType,
            labelAreaType: 1 /* 无 None = 0 整体 Whole = 1 标题 Title = 2 内容 Content = 3 */,
            changeCode: item.changeCode,
            labelId: '', // skyline不传 其他具体看情况
            url: '' // skyline不传 其他具体看情况
          },
          {
            Routes: 'wikifxagg$changehistoryjumpinfo'
          }
        )
        .catch((err) => {
          console.log(err)
        })
      if (resean?.wikifxagg?.changehistoryjumpinfo?.data?.url) window.open(resean?.wikifxagg?.changehistoryjumpinfo?.data?.url)
    },
    linkistics(item, url, a) {
      console.log('a: ', a)
      if (item.changeCode == '1001002005' || item.changeCode == '1001002006') this.statistics('3', url)
      else if (a.bussinessType == 9110) window.open(url)
    },
    linkdetailbussine(item, type) {
      console.log('detail', this.detail)

      console.log('item: ', item)
      if (!item.code) return
      if (item.code == this.dealerCode) return
      console.log('item: ', item)
      /* 无业务 None = 0
          交易商 Trader = 1
          牌照 License = 2
          企业 Company = 3
          软件 Software = 4
          控制声明 ControlStatement = 5
          高管 Executive = 6
          商标 Trademark = 7
          官方登记号 OfficialRegistrationNumber = 8
          服务商 ServiceProvider = 10
          监管信息 Regulation = 11
          实勘 Survey = 100
          曝光 Exposure = 101
          调解 Mediation = 102
          Skyline Skyline = 103
          账户 Account = 9102
          监管机构 Regulator = 9109
          Website Website = 9110 */
      if (type == 1) window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${item.code}.html`)
      // else if(type == 2) this.showDialog({bussinessId:item.code})
      else if (type == 3) window.open(`/${this.$store.state.LanguageCode}/company/${item.code}.html`)
      // else if(type == 4) {
      //   this.openmt({softwareId:item.code,softwareType:item.subCode,name:item.content})
      // }
      else if (type == 5) window.open(`/${this.$store.state.LanguageCode}/company/${item.code}.html`)
      else if (type == 6) window.open(`/${this.$store.state.LanguageCode}/employee/${item.code}.html`)
      else if (type == 7) window.open(`/${this.$store.state.LanguageCode}/company/${item.code}.html`)
      else if (type == 8) window.open(`/${this.$store.state.LanguageCode}/company/${item.code}.html`)
      else if (type == 10) window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/service/${item.code}.html`)
      else if (type == 11) this.showDialog({ bussinessId: item.code })
      else if (type == 100) window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/survey/${item.code}.html`)
      else if (type == 101) window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/exposure/detail/${item.code}.html`)
      else if (type == 102) window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/exposure/safeguard/${item.code}.html`)
      else if (type == 103) window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/skyline/global.html`)
      else if (type == 9109) window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/regulatory/${item.code}.html`)
      else if (type == 9110) this.statistics('3', item.code)
      else if (type == 9114) {
        if (!this.$store.state.mobile) this.$refs.authenticat.show()
        else this.$refs.h5mtDom.showMt()
      }
    },
    async statistics(type, url, code = '') {
      this.ourl = url
      // 统计type为1--浏览模式默认；type为2---广告点击；3---点击模式官方网址；4---开户网址；5---品专官方网址；6---品专开户地址;7---品专默认
      let spots = 5
      if (type == '1' && !this.$store.state.allHost.includes('brand=1')) spots = 5
      else if (type == '2')
        spots = 3 // 广告
      else if (type == '3' && !this.$store.state.allHost.includes('brand=1')) spots = 1
      else if (type == '4' && !this.$store.state.allHost.includes('brand=1')) spots = 4
      else if (type == '5' && this.$store.state.allHost.includes('brand=1')) spots = 11
      else if (type == '6' && this.$store.state.allHost.includes('brand=1')) spots = 12
      else if (type == '7' && this.$store.state.allHost.includes('brand=1')) spots = 10
      else if (type == '21') spots = 21
      else if (type == '20') spots = 20
      const param = {
        userid: this.$store.state.user.userId ? this.$store.state.user.userId : '', // 用户标识
        equipId: this.$Cookie.get('wiki-bfp'),
        platform: 3, // 平台类型
        apptype: 0, // 客户端类型
        ip: this.$store.state.userIp, // 用户ip
        ver: '0', // 版本
        equipinfo: 0, // 客户端类型
        country: this.$store.state.CountryCode, // 当前国家
        lang: this.$store.state.LanguageCode, // 当前语言
        type: 1, // 浏览类型
        code: code || this.main.main.traderCode, // 交易商code
        spots, // 点位类型 1网址 3广告 4开户网址 11品专网址 12品专开户网址
        url, // 对应网址
        jumpStatisticsUrl: this.$store.state.allHost
      }
      await this.$api.dealer.statistics(param).then((res) => {
        console.log('res: ', res)
        if (res && res.url) {
          if (type == '6' || type == '4') {
            const u = res.url.includes('http') ? res.url : `https://${res.url}`
            console.log('u: ', u)
            // this.$refs.dealerhead.iframeval(u)
            this.tipstype = String(res.type)
            this.totype(res, 'webUrl')
          } else if (type == '5' || type == '3') {
            const u = res.url.includes('http') ? res.url : `https://${res.url}`
            console.log('u: ', u)
            // this.$refs.dealerhead.iframeval(u)
            this.tipstype = String(res.type)
            this.totype(res)
          } else if (type == '21') {
            // const child = this.$refs.newInfoCom?.$refs.primary
            // if(child){
            // const u = res.url.includes('http') ? res.url : `https://${res.url}`
            // child.iframeval(u)
            // this.tipstype = String(res.type)
            // this.totype(res)
            // } else {
            //   const oldChild = this.$refs.primary
            //   if(oldChild){
            //     const u = res.url.includes('http') ? res.url : `https://${res.url}`
            //     oldChild.iframeval(u)
            //     this.tipstype = String(res.type)
            //     oldChild.totype(res)
            //   }
            // }
            this.tipstype = String(res.type)
            this.totype(res)
          }
        }
      })
    },
    totype(typeval, type = 'sites') {
      // 跳转方式
      console.log(typeval, 789, this.tips)
      this.returnurl = typeval?.url
      if (this.tips && this.tips.title) {
        setTimeout(() => {
          this.urltype = type
          this.moduleShow = true
          // this.modelshow = true
          this.$nextTick(() => {
            this.$refs.tisk.open()
          })
        }, 0)
      } else if (typeval.type == '0') {
        this.iframeshow = true
        this.modelshow = true
        this.$refs.riskwarning.open()
      } else if (typeval.type == '1') {
        if (!typeval?.url?.includes('mobile/tradertips')) {
          this.closemodefn()
          // window.open(typeval?.url)
          if (this.$store.state.mobile) {
            // window.open(typeval?.url)
            setTimeout(() => {
              // 做定时器主要原因是苹果手机不这么做跳转不了，会被拦截
              const a = document.createElement('a')
              a.setAttribute('href', typeval?.url)
              a.setAttribute('target', '_blank')
              a.setAttribute('id', 'startTelMedicine')
              // 防止反复添加
              if (document.getElementById('startTelMedicine')) {
                document.body.removeChild(document.getElementById('startTelMedicine'))
              }
              document.body.appendChild(a)
              a.click()
            }, 400)
            return
          }
          const a = document.createElement('a')
          a.setAttribute('href', typeval?.url)
          a.setAttribute('target', '_blank')
          a.setAttribute('id', 'startTelMedicine')
          // 防止反复添加
          if (document.getElementById('startTelMedicine')) {
            document.body.removeChild(document.getElementById('startTelMedicine'))
          }
          document.body.appendChild(a)
          a.click()
        } else if (typeval?.url?.includes('flgship=1')) {
          // this.modelshow = true
          // this.$refs.riskwarning.open(true)
          // window.open(`/${this.$store.state.LanguageCode}/warning.html?url=${this.ourl}`)
          // window.open(`/testurl.html?url=${this.ourl}`)
          if (this.$store.state.mobile) {
            // window.open(`/${this.$store.state.LanguageCode}/warning.html?url=${this.ourl}`)
            setTimeout(() => {
              const a = document.createElement('a')
              a.setAttribute('href', `/${this.$store.state.LanguageCode}/warning.html?url=${this.ourl}`)
              a.setAttribute('target', '_blank')
              a.setAttribute('id', 'startTelMedicine')
              // 防止反复添加
              if (document.getElementById('startTelMedicine')) {
                document.body.removeChild(document.getElementById('startTelMedicine'))
              }
              document.body.appendChild(a)
              a.click()
            }, 400)
            return
          }
          const a = document.createElement('a')
          a.setAttribute('href', `/${this.$store.state.LanguageCode}/warning.html?url=${this.ourl}`)
          a.setAttribute('target', '_blank')
          a.setAttribute('id', 'startTelMedicine')
          // 防止反复添加
          if (document.getElementById('startTelMedicine')) {
            document.body.removeChild(document.getElementById('startTelMedicine'))
          }
          document.body.appendChild(a)
          a.click()
        } else if (typeval?.url?.includes('flgship=0')) {
          this.modelshow = true
          this.$refs.riskwarning.open()
        }
      }
    },
    iframeif(val) {
      // iframe显示状态
      console.log(this.returnurl, 777)
      if (val == '0') {
        this.iframeshow = true
        this.modelshow = true
        this.$refs.riskwarning.open()
      } else if (val == '1') {
        if (!this.returnurl?.includes('mobile/tradertips')) {
          this.closemodefn()
          // window.open(this.returnurl)
          if (this.$store.state.mobile) {
            // window.open(this.returnurl)
            setTimeout(() => {
              const a = document.createElement('a')
              a.setAttribute('href', this.returnurl)
              a.setAttribute('target', '_blank')
              a.setAttribute('id', 'startTelMedicine')
              // 防止反复添加
              if (document.getElementById('startTelMedicine')) {
                document.body.removeChild(document.getElementById('startTelMedicine'))
              }
              document.body.appendChild(a)
              a.click()
            }, 400)
            return
          }
          const a = document.createElement('a')
          a.setAttribute('href', this.returnurl)
          a.setAttribute('target', '_blank')
          a.setAttribute('id', 'startTelMedicine')
          // 防止反复添加
          if (document.getElementById('startTelMedicine')) {
            document.body.removeChild(document.getElementById('startTelMedicine'))
          }
          document.body.appendChild(a)
          a.click()
        } else if (this.returnurl?.includes('flgship=1')) {
          // this.modelshow = true
          // this.$refs.riskwarning.open(true)
          // window.open(`/${this.$store.state.LanguageCode}/warning.html?url=${this.ourl}`)
          // window.open(`/testurl.html?url=${this.ourl}`)
          if (this.$store.state.mobile) {
            // window.open(`/${this.$store.state.LanguageCode}/warning.html?url=${this.ourl}`)
            setTimeout(() => {
              const a = document.createElement('a')
              a.setAttribute('href', `/${this.$store.state.LanguageCode}/warning.html?url=${this.ourl}`)
              a.setAttribute('target', '_blank')
              a.setAttribute('id', 'startTelMedicine')
              // 防止反复添加
              if (document.getElementById('startTelMedicine')) {
                document.body.removeChild(document.getElementById('startTelMedicine'))
              }
              document.body.appendChild(a)
              a.click()
            }, 400)
            return
          }
          const a = document.createElement('a')
          a.setAttribute('href', `/${this.$store.state.LanguageCode}/warning.html?url=${this.ourl}`)
          a.setAttribute('target', '_blank')
          a.setAttribute('id', 'startTelMedicine')
          // 防止反复添加
          if (document.getElementById('startTelMedicine')) {
            document.body.removeChild(document.getElementById('startTelMedicine'))
          }
          document.body.appendChild(a)
          a.click()
        } else if (this.returnurl?.includes('flgship=0')) {
          this.modelshow = true
          this.$refs.riskwarning.open()
        }
      }
    },
    openIpDialog(item) {
      this.companyBasic = item?.companyBasic
      console.log('触发3')

      console.log(item, 8886)
      if (item.serverIPList.list.length) {
        this.serverIPObj = item.serverIPList
        this.updateDate = dayjs(new Date(Number(this.serverIPObj.updateDate))).format('YYYY-MM-DD')
        console.log('弹框打开')
        //  document.body.style.overflow = 'hidden !important'
        document.body.style.setProperty('overflow', 'hidden', 'important')

        this.isIpDialog = true
      }
    },
    openmt(item) {
      console.log('item: ', item)
      // 打开相关软件弹框
      // console.log(item, 9999)
      for (const key in item) {
        this.$set(this.softval, key, item[key])
      }
      // console.log('softval-open',this.softval);

      if (item.softwareType != 3 && item.softwareType != 4) {
        if (this.$store.state.mobile) {
          this.$nextTick(() => {
            this.$refs.h5mtDom.showMt(item)
          })
        } else {
          console.log('123')

          this.$refs.individuaident.open()
        }
      } else {
        console.log('111222333')

        this.$refs.dealerMt.open()
      }
    },
    showDialog(itemone) {
      // if (this.$store.state.mobile) {
      //   window.open(`/${this.$store.state.LanguageCode}/download.html`)
      //   return
      // }
      console.log('this.main.main.regulators', this.main.main.regulators)
      let itmInfo = {}
      this.main?.main?.regulators?.forEach((item) => {
        if (item.regulationId == itemone.bussinessId) itmInfo = item
      })
      console.log('itmInfo: ', itmInfo)

      this.getChiaZiZhiForjg((res) => {
        if (res && res.content) {
          const pass = this.$Cookie.get(this.zizhiForjgCookieName)
          this.zizhiImg = res.path
          this.zizhiContent = res.content
          if (res.interval > 2) {
            this.interval = res.interval
          }
          if (res.interval == 0) {
            this.zizhiShow = false
          } else if (res.interval == 2) {
            this.zizhiShow = true
          } else if (res.interval > 2 && !pass) {
            this.zizhiShow = true
          }
        }

        if (!this.zizhiShow) {
          if (itmInfo.regulationId) this.popJgWindow(itmInfo)
        } else {
          this.zizhiCur = itemone
        }
        console.log('交易商详情页,点击监管的,弹窗点位数据返回', this.zizhiShow)
      })
    },
    popJgWindow(itemone) {
      console.log(itemone, 8886)
      if (itemone.jump) {
        this.$refs.popUp.show(itemone)
      } else {
        this.$refs.hongkongPopUp.show(itemone.jump.url)
      }
    },
    getChiaZiZhiForjg(callback) {
      const myip = this.$store.state.userIp
      if (!myip) {
        console.log('this.$store.state.userIp取值异常,ip=' + myip)
      }
      const bfp = this.$cookies.get('wiki-bfp') ? this.$cookies.get('wiki-bfp') : '822ca7b3261a0b2ec10c8cdabfb5a0ea'
      this.$api.dealer
        .popwindow({
          code: this.dealerCode,
          type: 2,
          headers: {
            BasicData: `999,111,1,210,0,${bfp},1`
          }
        })
        .then((res) => {
          callback(res)
          return false
        })
    },
    openmtIpDialog(item) {
      // console.log(item, '子页面触发-8886')
      this.ismtipd = true
      this.companyBasic = item?.companyBasic
      if (item.serverIPList.list.length) {
        this.serverIPObj = item.serverIPList
        this.updateDate = dayjs(new Date(Number(this.serverIPObj.updateDate))).format('YYYY-MM-DD')
        document.body.style.setProperty('overflow', 'hidden', 'important')
        this.isIpDialog = true
      }
    }
  }
}
